module.exports = __webpack_public_path__ + "static/media/league5.d62a33d2.png";